import { render, staticRenderFns } from "./bookprice-dialog-history.vue?vue&type=template&id=05ec326e&"
import script from "./bookprice-dialog-history.vue?vue&type=script&lang=js&"
export * from "./bookprice-dialog-history.vue?vue&type=script&lang=js&"
import style0 from "./bookprice-dialog-history.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports